import React from "react";

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  confirmText = "Delete",
  cancelText = "Cancel",
  variant = "danger",
  isLoading = false,
}) {
  if (!isOpen) return null;

  const isDanger = variant === "danger";

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="w-[312px] rounded-[8px] bg-[#FDFCFF] shadow-[0px_2px_8px_rgba(0,0,0,0.12)]"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {/* Title + description */}
        <div className="px-[24px] pt-[24px] pb-[24px]">
          <div className="text-[14px] leading-[19px] font-semibold text-[#2A2A2A]">
            {title}
          </div>
          <div className="mt-[4px] text-[12px] leading-[16px] font-normal text-[#2A2A2A]">
            {message}
          </div>
        </div>

        {/* Actions */}
        <div className="px-[24px] pb-[24px] flex justify-end gap-[8px]">
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className={`h-[34px] px-[24px] rounded-[100px]
                       text-[14px] leading-[20px] font-normal
                       transition disabled:opacity-50 disabled:cursor-not-allowed
                       ${
                         isDanger
                           ? "bg-[#D02929] text-[#E2E2E2] hover:brightness-95"
                           : "bg-[#228BE6] text-white hover:brightness-95"
                       }`}
          >
            {isLoading ? "Processing..." : confirmText}
          </button>
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="h-[34px] px-[24px] rounded-[100px] bg-[#F3EEFF] text-[#2C2866]
                       text-[14px] leading-[20px] font-normal
                       hover:brightness-95 transition
                       disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
}
